export default __webpack_public_path__ + "assets/46205fc721015d297a077904d5146561.png";